export default "__VITE_ASSET__4f072bed__"